import React, { useEffect, useState } from 'react';
import './css/publisherProfile.css';
import { publisherSelfAPI as publisherAPI } from '../../utils/api';
import Swal from 'sweetalert2';

export default function PublisherProfilePage() {
  const [profile, setProfile] = useState(null);
  const empty = { contactName:'', phone:'', officePhone:'', whatsappPhone:'', email:'', address:'', ntn:'', strn:'', website:'', pressAddress:'', taxExempt:false };
  const [form, setForm] = useState(empty);

  const load = async () => {
    try {
      const r = await publisherAPI.getProfile();
      setProfile(r.data);
      setForm({
        contactName: r.data.contactName||'',
        phone: r.data.phone||'',
        officePhone:r.data.officePhone||'',
        whatsappPhone:r.data.whatsappPhone||'',
        address: r.data.address||'',
        pressAddress:r.data.pressAddress||'',
        email:r.data.email||'',
        ntn:r.data.ntn||'',
        strn:r.data.strn||'',
        website:r.data.website||'',
        taxExempt:!!r.data.taxExempt,
      });
    } catch (e) {
      Swal.fire({ icon: 'error', title: 'Error', text: e.message });
    }
  };

  useEffect(() => {
    load();
  }, []);

  const change = e => setForm({ ...form, [e.target.name]: e.target.value });

  const save = async () => {
    try {
      await publisherAPI.updateProfile(form);
      Swal.fire({title:'Saved',icon:'success'});
      await load();
    } catch (e) {
      Swal.fire({ icon: 'error', title: 'Save error', text: e.message });
    }
  };

  if (!profile) return <div>Loading...</div>;

  return (
    <div style={{ maxWidth: 800, margin: '0 auto' }}>
      <h2>Publisher Profile</h2>
      <form className="publisher-profile-form"
        onSubmit={e => { e.preventDefault(); save(); }}
      >
        <label>
          Contact Name
          <input name="contactName" value={form.contactName} onChange={change} />
        </label>
        <label>
          Username
          <input value={profile.username} disabled />
        </label>
        <label>
          Phone
          <input name="phone" value={form.phone} onChange={change} />
        </label>
        <label>
          Office Phone
          <input name="officePhone" value={form.officePhone} onChange={change} />
        </label>
        <label>
          WhatsApp Phone
          <input name="whatsappPhone" value={form.whatsappPhone} onChange={change} />
        </label>
        <label>
          Email
          <input name="email" value={form.email} onChange={change} />
        </label>
        <label>
          Website
          <input name="website" value={form.website} onChange={change} />
        </label>
        <label>
          NTN
          <input name="ntn" value={form.ntn} onChange={change} />
        </label>
        <label>
          STRN
          <input name="strn" value={form.strn} onChange={change} />
        </label>
        <label style={{ gridColumn: '1 / span 2' }}>
          Address
          <textarea name="address" value={form.address} onChange={change} rows={3} />
        </label>
        <label style={{ gridColumn: '1 / span 2' }}>
          Press Address
          <textarea name="pressAddress" value={form.pressAddress} onChange={change} rows={3} />
        </label>
        <label>
          Tax Exempt
          <select name="taxExempt" value={form.taxExempt} onChange={e=>setForm({...form,taxExempt:e.target.value==='true'})}>
            <option value={false}>No</option>
            <option value={true}>Yes</option>
          </select>
        </label>
        <div style={{ gridColumn: '1 / span 2', textAlign: 'right', marginTop: 12 }}>
          <button type="submit" className="eduss-login-btn" style={{padding:'10px 32px'}}>Update</button>
        </div>
      </form>
    </div>
  );
}
